import {
  getEvidenceStatusLabel,
  isApprovedStatus,
  isAwaitingReviewStatus,
  isRejectedStatus,
  type EvidenceStatus,
} from "../models/evidenceItem";

type EvidenceStatusBadgeProps = {
  reported: boolean;
  status: EvidenceStatus;
};

const getStatusBadgeClass = (status: EvidenceStatus): string => {
  if (isApprovedStatus(status)) {
    return "cle-status-badge--success";
  }

  if (isAwaitingReviewStatus(status)) {
    return "cle-status-badge--warning";
  }

  if (isRejectedStatus(status) || status === "failed") {
    return "cle-status-badge--danger";
  }

  return "cle-status-badge--info";
};

/**
 * Status for dokumentation, som sekretariatet behandler. Indberettet dokumentation er
 * altid godkendt, så "Indberettet" er det mest præcise, når det gælder.
 */
const EvidenceStatusBadge = ({
  reported,
  status,
}: EvidenceStatusBadgeProps) => (
  <span
    className={`cle-status-badge ${
      reported ? "cle-status-badge--reported" : getStatusBadgeClass(status)
    }`}
  >
    {reported ? "Indberettet" : getEvidenceStatusLabel(status)}
  </span>
);

export default EvidenceStatusBadge;
